import { AuditModel } from "./auditModel";

export class Timesheet extends AuditModel {
  public TimesheetId: number
  public accountingFirmId: number
  public Description: any
  public leaveName: any
  public type: any
  public from: any
  public to: any
  public Id: number
  public id: number
  public holidayName: any
  public holidayDate: any
  public information: any
  public moreInformation: any
  public countryCode: any
  public stateCode: any
}

export class CaptureTime {
  public logTimeId: number
  public clientId: number
  public clientName: string
  public entityName: string
  public taskName: string
  public jobName: string
  public jobType: string
  public entityId: number
  public entityTypeId: number
  public taskList: string;
  public taskId: number
  public jobId: number
  public mastertimesheetId: number;
  public masterholidayId: number;
  public description: string
  public startTime: number
  public endTime: number
  public numberOfHours: number
  public loggedTime: any;
  public Created_By: string
  public Created_At: any
  public jobNumber: any;
  public startDate: any;
  public endDate: any;
  public isBillable: boolean = false;
  public strtdate: any;
  public userId: any;
  public statusId: number;
  public planDate: string;
  public contextId?: any;
}
export class Statusdata {
  sequence: any
  statusCatId: any
  statusId: any
  statusName: any
  jobTypeId: any
  status: any
}
export class Staffdata {
  recursiveCallNumber: any
  reportingPersonId: any
  userId: any
  name: any
}
export class WeeklyDetail {
  contextId: any;
  context: string;
  name: string;
  day1: string;
  day2: string;
  day3: string;
  day4: string;
  day5: string;
  day6: string;
  day7: string;
  cflagday1: boolean = false;
  cflagday2: boolean = false;
  cflagday3: boolean = false;
  cflagday4: boolean = false;
  cflagday5: boolean = false;
  cflagday6: boolean = false;
  cflagday7: boolean = false;
  isCommentForTimelog: any;
  isFinalInvoice: any;
  dayTotal: any;
  dHrs: any
  dMins: any
  type: string;
  timespent: string;
  estimatedHours: any;
  eHours: any;
  eMins: any;
  planHrs:any;
  hoursBalance: any;
  sDate: any;
  dueDate: any
  status: any
  jobName: any
  jobCode: any
  financialYear: any;
  userId?: string;
  plannedHours: any;
  isPublised: boolean = false;
  planHour: any;
  planHrBalance: any;
  planEstimate: any;
  teamId:number;
  userJobTime:any;
}
export class CaptureLogComment {
  public commentId: number
  public contextId: number
  public mileStoneId: number
  public context: string
  public comment: string
  public itemName: string
  public commentDate: any
  public weekStart_At: any
  public weekEnd_At: any
  public isCompleted: boolean = false;
  public strtdate: any;
  public TaggedUsers: any;
}

export class Timelog {
  public Id: number;
  public Subject: string;
  public StartTime: Date;
  public EndTime: Date;
}

export class Token {
  tokenId: any = 0;
  keyword: any = "";
  tokenName: any = "";
  description: any = "";
  created_At: any;
  created_By: any = "";
  updated_At: any;
  updated_By: any = "";
  deleted_At: any;
  deleted_By: any = "";
  isDeleted: any = false;
  userName: any = "";
}
